"use client";
import style from "./index.module.scss";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { fetchCurrentPlan, fetchMe } from "@/lib/client";
import { Settings, Sparkles, User } from "lucide-react";
import Link from "next/link";
import { SignoutButton } from "./logout-button";
import { useEffect, useState } from "react";
import { UserType } from "@/types/account";
import { usePathname } from "next/navigation";

export function Account() {
  const pathname = usePathname();
  const [currentUser, setCurrentUser] = useState<UserType | undefined>();
  const [isSubscriptingPlan, setIsSubscriptingPlan] = useState(false);

  //biome-ignore lint:
  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const currentUser = await fetchMe();
        setCurrentUser(currentUser);
      } catch (_) {}
    };

    const fetchSubscriptingPlan = async () => {
      try {
        const currentPlan = await fetchCurrentPlan();
        const isSubscriptingPlan = currentPlan !== undefined;
        setIsSubscriptingPlan(isSubscriptingPlan);
      } catch (_) {
        setIsSubscriptingPlan(false);
      }
    };

    fetchSubscriptingPlan();
    fetchCurrentUser();
  }, [pathname]);

  if (!currentUser || pathname === "/") {
    return null;
  }

  if (currentUser.role === "guest") {
    return (
      <Link href="/signin" className={style.login_button}>
        サインイン
      </Link>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Avatar>
          <AvatarImage
            sizes="10px"
            className={style.avatar}
            src={currentUser.icon ? currentUser.icon : ""}
            alt={currentUser.name ? currentUser.name : ""}
          />
          <AvatarFallback>{currentUser.name}</AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent style={{ zIndex: 1000 }} className={style.account_content}>
        <DropdownMenuLabel className={style.label}>
          <p className={style.name}>{currentUser.name}</p>
          <p className={style.email}>{currentUser.email}</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <Link href={isSubscriptingPlan ? "/settings/current-plan" : "/plan"}>
          <DropdownMenuItem>
            <Sparkles className={style.icon} />
            {isSubscriptingPlan ? "現在のプランの確認" : "プランをアップグレード"}
          </DropdownMenuItem>
        </Link>
        <DropdownMenuSeparator />
        <Link href="/settings/profile">
          <DropdownMenuItem>
            <User className={style.icon} />
            プロフィール
          </DropdownMenuItem>
        </Link>

        <Link href="/settings">
          <DropdownMenuItem>
            <Settings className={style.icon} />
            設定
          </DropdownMenuItem>
        </Link>

        <DropdownMenuSeparator />
        <SignoutButton className={style.icon} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
